import { defineStore } from "pinia";
import axios from "axios";
export const phone = defineStore("phone", {
  state: () => ({
    dataPhone: [],
    singlePhone: [],
  }),
  actions: {
    async getDataPhone() {
      await axios
        .get("https://dummyjson.com/products/category/smartphones")
        .then((res) => {
          this.dataPhone = res.data.products.slice(0, 10);
          this.dataPhone.forEach((e) => {
            e.wishlist = false;
          });
        });
      console.log(this.dataPhone);
    },
    async getSinglePro(productId) {
      await axios
        .get(
          `https://dummyjson.com/products/${productId}
`
        )
        .then((res) => {
          console.log(res.data);
          this.singlePhone = res.data;
          this.singlePhone.wishlist = false;
        });
    },
  },
});
// Fresh vegetables section
